//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { TrackingId, TrackingIdPrefix } from '@models/TrackingId';

const AiContentCurationPrefix: TrackingIdPrefix = 'ai-content-curation-';

export const AiContentCurationTrackingIds = {
  BULK_REJECT_BUTTON: `${AiContentCurationPrefix}bulk-reject-button`,
  BULK_REJECT_CONFIRM: `${AiContentCurationPrefix}bulk-reject-confirm`,
  BULK_REJECT_CANCEL: `${AiContentCurationPrefix}bulk-reject-cancel`,
  MODERATION_RULES_ALERT: `${AiContentCurationPrefix}moderation-rules-alert`,
  REJECT_CONTENT_OVERLAY_BUTTON: `${AiContentCurationPrefix}reject-content-overlay-button`,
  RESTORE_CONTENT_BUTTON: `${AiContentCurationPrefix}restore-content-button`,
} as const satisfies Record<string, TrackingId>;
